import toast from 'react-hot-toast'

// Wrapper to match react-redux-toastr API
export const toastr = {
  success: (title: string, message?: string) => {
    const content = message ? `${title}\n${message}` : title
    toast.success(content)
  },
  error: (title: string, message?: string) => {
    const content = message ? `${title}\n${message}` : title
    toast.error(content)
  },
  info: (title: string, message?: string) => {
    const content = message ? `${title}\n${message}` : title
    toast(content)
  },
  warning: (title: string, message?: string) => {
    const content = message ? `${title}\n${message}` : title
    toast(content, {
      icon: '⚠️',
      style: {
        background: '#ff9800',
        color: '#fff',
      },
    })
  },
}